import { FC } from "react";
import classNames from "classnames";
import logoTEALCA from "../../assets/LogoTEALCA.svg";

export type CouponLotteryBadgeValue = 50 | 100;

interface CouponLotteryBadgeProps {
  couponValue: CouponLotteryBadgeValue;
  className?: string;
}

export const CouponLotteryBadge: FC<CouponLotteryBadgeProps> = ({
  couponValue,
  className,
}) => {
  return (
    <output
      className={classNames("coupon-lottery-badge-wrap", className)}
      aria-label={`Envío seleccionado para participar con ${couponValue}% de descuento`}
    >
      <style>{`
        .coupon-lottery-badge-wrap {
          position: relative;
          display: inline-block;
          padding: 0.5rem 0.75rem;
          isolation: isolate;
        }
        .coupon-lottery-badge-wrap::before,
        .coupon-lottery-badge-wrap::after {
          content: '';
          position: absolute;
          inset: 0;
          pointer-events: none;
          z-index: -1;
        }
        .coupon-lottery-badge-wrap::before {
          background-image:
            radial-gradient(circle at 8% 18%, #fbbf24 0 3px, transparent 3px),
            radial-gradient(circle at 92% 12%, #3b82f6 0 3px, transparent 3px),
            radial-gradient(circle at 18% 82%, #ec4899 0 3px, transparent 3px),
            radial-gradient(circle at 90% 80%, #fbbf24 0 3px, transparent 3px),
            radial-gradient(circle at 50% 6%, #10b981 0 2.5px, transparent 2.5px),
            radial-gradient(circle at 4% 50%, #ec4899 0 2.5px, transparent 2.5px),
            radial-gradient(circle at 98% 50%, #3b82f6 0 2.5px, transparent 2.5px),
            radial-gradient(circle at 70% 95%, #f97316 0 3px, transparent 3px);
          background-repeat: no-repeat;
          opacity: 0.9;
        }
        .coupon-lottery-pill {
          background: linear-gradient(135deg, #0072C9 0%, #00559E 55%, #7c3aed 100%);
          color: #ffffff;
          border-radius: 9999px;
          padding: 0.5rem 0.95rem;
          display: inline-flex;
          align-items: center;
          gap: 0.6rem;
          box-shadow:
            0 4px 10px rgba(0, 85, 158, 0.35),
            inset 0 1px 0 rgba(255, 255, 255, 0.25);
          position: relative;
          overflow: hidden;
          user-select: none;
          line-height: 1.1;
          min-height: 2.5rem;
          animation: coupon-lottery-pulse 2.4s ease-in-out infinite;
        }
        .coupon-lottery-pill::after {
          content: '';
          position: absolute;
          top: -50%;
          left: -60%;
          width: 18%;
          height: 200%;
          background: rgba(255, 255, 255, 0.35);
          transform: rotate(30deg);
          animation: coupon-lottery-shimmer 3.4s ease-in-out infinite;
          pointer-events: none;
        }
        .coupon-lottery-pill__text {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 1px;
        }
        .coupon-lottery-pill__title {
          font-weight: 800;
          font-size: 0.85rem;
          letter-spacing: 0.04em;
          text-shadow: 0 1px 1px rgba(0, 0, 0, 0.15);
        }
        .coupon-lottery-pill__discount {
          font-weight: 700;
          font-size: 0.7rem;
          letter-spacing: 0.02em;
          color: #fef3c7;
        }
        .coupon-lottery-pill__participate {
          font-weight: 500;
          font-size: 0.6rem;
          letter-spacing: 0.01em;
          opacity: 0.9;
        }
        .coupon-lottery-pill__icon {
          flex: 0 0 auto;
          width: 1.75rem;
          height: 1.75rem;
          background: #ffffff;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          box-shadow: inset 0 -1px 2px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.18);
          padding: 2px;
        }
        .coupon-lottery-pill__icon img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
        @keyframes coupon-lottery-pulse {
          0%, 100% { transform: scale(1); }
          50%      { transform: scale(1.03); }
        }
        @keyframes coupon-lottery-shimmer {
          0%   { left: -60%; }
          25%  { left: 130%; }
          100% { left: 130%; }
        }
        @media (prefers-reduced-motion: reduce) {
          .coupon-lottery-pill,
          .coupon-lottery-pill::after {
            animation: none;
          }
        }
      `}</style>

      <span className="coupon-lottery-pill">
        <span className="coupon-lottery-pill__text">
          <span className="coupon-lottery-pill__title">¡EN SORTEO!</span>
          <span className="coupon-lottery-pill__participate">
            Envío seleccionado para participar
          </span>
          <span className="coupon-lottery-pill__discount">
            ¡{couponValue}% de Descuento!
          </span>
        </span>
        <span className="coupon-lottery-pill__icon" aria-hidden="true">
          <img src={logoTEALCA} alt="" />
        </span>
      </span>
    </output>
  );
};

export default CouponLotteryBadge;
